angular.module('trsAddFooterModule', []).directive('footer', [
    function() {
        return {
            restrict: 'AE',
            replace: true,
            template: [
                '<div class="footer"><div class="foot_line"></div>',
                '<div class="foot_text">',
                '2019 新疆日报社（新疆报业传媒〈集团〉有限公司） 版权所有 保留所有权 本系统支持1366*768及以上分辨率率',
                '</div></div>',
            ].join(''),
            link: function(scope){
                
            }
        };
    },
]);
